import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./About_Shore_Clinic.css";
import Common_title from "../../common-components/common_title/Common_title";
import Redirect_btn from "../../common-components/common-btn/redirect-btn/Redirect_btn";

const About_Shore_Clinic = () => {
  return (
    <section className="about_shore_section">
      <Container>
        <Row className="justify-content-center">
          <Col lg={5} md={5} sm={12}>
            <div className="shore_image_holder">
              <img
                src="/assets/images/home/about_shore_clinic/Group-img.png"
                alt="group-img"
                className="group-img"
              />
            </div>
          </Col>

          <Col lg={7} md={7} sm={12}>
            <div className="shore_text_holder">
              <div className="shore_text">
                <Common_title text="⚓ ABOUT SHORE CLINIC" />
                <h2 className="shore_title">
                  Your Trusted <br /> Marine <br /> Medical Center
                </h2>

                <p className="shore_desc">
                  Established in 2018, Shore Clinic is a DG Shipping (Govt. of
                  India)–approved and ISO-certified maritime medical centre in
                  Pune.
                  <br /> We specialize in medical examinations for seafarers and
                  shipping professionals — ensuring every crew member sails fit,
                  safe, and compliant.
                </p>
                <Redirect_btn name="About Us" link="/about-us" />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About_Shore_Clinic;
